import { XKTLoaderPlugin } from "@xeokit/xeokit-sdk";
import { fetchModel } from "./fetchModel";

export const pointCloudLoadModel = (viewer) => {
    console.log(`🔄 Attempting to load pointcloud model`);
    // ✅ Prevent duplicate loading
    if (viewer.scene.models["myPointCloudModel"]) {
        console.warn("⚠️ Pointcloud Model already loaded. Skipping load.");
        return Promise.resolve(viewer.scene.models["myPointCloudModel"]);
      }

    return new Promise((resolve, reject) => {
        const modelUrl = fetchModel("xkt/pointCloud.xkt");

        const xktLoader = new XKTLoaderPlugin(viewer);

        const model = xktLoader.load({
            id: "myPointCloudModel",
            src: modelUrl,
            format: "xkt", // Ensure correct format
        });

        model.on("loaded", () => {
            console.log(`✅ Model ${model.id} loaded successfully!`);
            model.visible = false;
            updateLas(viewer,model)
            resolve(model);
        });

        model.on("error", (error) => {
            console.error(`❌ ❌ Error loading city model:`, error);
            reject(error);
        });
    });
};

//updating the PointCloud model position
export const updateLas = (viewer, lasModel) => {
    const pointsMaterial = viewer.scene.pointsMaterial;
    const camera = viewer.scene.camera;

    const guiParams = {
        positionX : 30,
        positionY : -5,
        positionZ : -150,
        rotateX : 0,
        rotateY : -40,
        rotateZ : 0,
        roundPoints : pointsMaterial.roundPoints,
        perspectivePoints : pointsMaterial.perspectivePoints,
        pointSize : pointsMaterial.pointSize,
        minPerspectivePointSize : pointsMaterial.minPerspectivePointSize,
        maxPerspectivePointSize : pointsMaterial.maxPerspectivePointSize,
        perspective : (camera.projection === "perspective"),
    };
  
    lasModel.position = [
        guiParams.positionX,
        guiParams.positionY,
        guiParams.positionZ,
    ];
    lasModel.rotation = [
        guiParams.rotateX,
        guiParams.rotateY,
        guiParams.rotateZ,
    ];
    pointsMaterial.roundPoints = guiParams.roundPoints;
    pointsMaterial.perspectivePoints = guiParams.perspectivePoints;
    pointsMaterial.pointSize = guiParams.pointSize;
    pointsMaterial.minPerspectivePointSize = guiParams.minPerspectivePointSize;
    pointsMaterial.maxPerspectivePointSize = guiParams.maxPerspectivePointSize;
    camera.projection = guiParams.perspective ? "perspective" : "ortho";
    console.log("Updated PointCloud Model Position:", lasModel.position);

    viewer.scene.pointsMaterial.pointSize = 1;
    viewer.scene.pointsMaterial.roundPoints = true;
    viewer.scene.pointsMaterial.perspectivePoints = true;
    viewer.scene.pointsMaterial.minPerspectivePointSize = 2;
    viewer.scene.pointsMaterial.maxPerspectivePointSize = 3;

  };

